$(function () {

    if ($('.site_flexible_content__flex_item .flex_map').length < 1) {
        return;
    }

    $('.site_flexible_content__flex_item .flex_map .map').googleMaps({
        points: [{
            lat: 53.748700,
            lng: -1.627660,
            marker: '/wp-content/themes/cgit-arc-building-solutions/images/icons/map-pin.png'
        }],
        key: GOOGLE_MAPS_API_KEY,
        zoom: 11,
    });

});